import sdk from '@b2ag/module-importer-sdk'
import { useAuthService } from '@invivodf/front-seller-auth'
import { buildCallerId } from '@invivodf/front-seller-caller-id'

import ImporterRepository from './infra/Importer.repository'
import { GetImportDownloadUrl } from './use-cases/GetImportDownloadUrl.usecase'

window.env = window.env || {}

const importerApiHost = window.env.IMPORTER_API_HOST || ''

const importerSDK = sdk(importerApiHost, {
  callerId: buildCallerId(),
  accessTokenSource: () => useAuthService().getAccessToken(),
})

const importerRepository = new ImporterRepository(importerSDK)

const getImportDownloadUrl = new GetImportDownloadUrl(importerRepository)

export { getImportDownloadUrl }
